import { ca } from '@cian/analytics';
import { TLabel } from '../../types/auth';

export function trackRequestSuccess(label: TLabel) {
  return async () =>
    ca('eventSite', {
      action: 'success',
      label,
      category: 'Mortgage',
      name: 'oldevent',
    });
}

export function trackAuth() {
  ca('eventSite', {
    action: 'Success',
    label: 'Auth_phone',
    category: 'MortgageApplication',
    name: 'oldevent',
  });
}

export function trackRegister() {
  ca('eventSite', {
    action: 'Success',
    label: 'Reg_phone',
    category: 'MortgageApplication',
    name: 'oldevent',
  });
}
